import React from "react";

type HeadingProps = {
  label: string;
  type: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
};

export const Heading = ({ label, type }: HeadingProps) => {
  const baseClassname = "heading";
  const Element = type;

  return <Element className={`${baseClassname}`}>{label}</Element>;
};
